import { computed, ref } from '@nuxtjs/composition-api'
import { Dictionary } from 'vue-router/types/router'
import { Client as GuestClient, Components as Guest } from '@/types/client.guest'
import { Components, Client as CustomerClient } from '@/types/client.customer'
// eslint-disable-next-line import/no-unresolved

export const USER_DATA = ref({
    userId: '',
    legacyUserId: '',
    executorCabinetId: ''
})

export const formattedContent = ref()
export const content = ref<Guest.Schemas.Promopage | null >(null)

export const replaceQueryParams = (route: Dictionary<string>, queries: Array<string>) => {
    const urlParams = new URLSearchParams(window.location.search)

    // eslint-disable-next-line array-callback-return
    queries.map((word) => {
        if (urlParams.has(word)) {
            formattedContent.value = formattedContent.value
                ?.replaceAll(`{${word}}`, urlParams.get(word))
        }
    })

    if (route.executorId) {
        const parameter = urlParams.has('ExecutorId')
            ? urlParams.get('ExecutorId')
            : '{ExecutorId}'

        formattedContent.value = formattedContent.value
            ?.replaceAll(parameter, route.executorId)
    }
}

export const replaceUserParams = async (data: Components.Schemas.PromopageUser) => {
        const {
            executorCabinetId, legacyUserId, userId
        } = data

        USER_DATA.value.userId = String(userId)
        USER_DATA.value.executorCabinetId = String(executorCabinetId)
        USER_DATA.value.legacyUserId = String(legacyUserId)

        formattedContent.value = formattedContent.value
            ?.replaceAll('{ExecutorId}', executorCabinetId || '{ExecutorId}')
            .replaceAll('{LegacyUserId}', legacyUserId || '{LegacyUserId}')
            .replaceAll('{UserId}', userId || '{UserId}')
}

export const extractScriptContent = (inputString: string) => {
    if (!/script/.test(inputString)) return undefined

    const startTag = '<script>'
    const startIndex = inputString.indexOf(startTag)

    const extractedContent = inputString.substring(
        startIndex + startTag.length,
        inputString.length
    ).replace('</script>', '')

    const vueFunction = document.createElement('script')
    vueFunction.append(extractedContent.trim())
    document.head.appendChild(vueFunction)
}

const setSrcScript = (inputString: string) => {
    const srcRegexp = /<script.*?src="(.*?)"/g
    const link = srcRegexp.exec(inputString)

    const script = document.createElement('script')
    script.setAttribute('src', String(link?.[1]))
    document.head.appendChild(script)
    document.getElementById('promopage')?.append(script)
}

export const getFunctionsFromPromopage = (formatContent: string) => {
    const replacedContent = formatContent
        .replaceAll('{UserId}', USER_DATA.value.userId)
        .replaceAll('{ExecutorId}', USER_DATA.value.executorCabinetId)
        .replaceAll('{LegacyUserId}', USER_DATA.value.legacyUserId)

    const functions = replacedContent.split('</script>')

    functions.forEach((func) => {
        if (func.includes('<script src')) {
            setSrcScript(func)
        } else {
            extractScriptContent(func)
        }
    })
}

export const getVueScript = (formatContent: string) => {
    const vueScript = document.createElement('script')
    vueScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/vue/dist/vue.js')
    document.head.prepend(vueScript)

    const checkVueLoaded = setInterval(() => {
        if (window.Vue) {
            clearInterval(checkVueLoaded)
            getFunctionsFromPromopage(formatContent)
        }
    }, 100)
}

export const fetchContent = async (
    route: Dictionary<string>,
    context: GuestClient | CustomerClient,
    environment: 'customer' | 'guest',
    userData: Components.Schemas.PromopageUser
) => {
    try {
        const { data } = await context.promopagesGetPromopage(route.id)

        formattedContent.value = data.code

        content.value = data

        if (environment === 'customer') {
            const queries = [
                'RequestId',
                'LegacyRequestId'
            ]

            replaceQueryParams(route, queries)
            replaceUserParams(userData)
        }

        if (environment === 'guest') {
            const queries = [
                'ExecutorId',
                'UserId',
                'LegacyUserId',
                'RequestId',
                'LegacyRequestId'
            ]

            replaceQueryParams(route, queries)
        }

        getVueScript(String(formattedContent.value))
    } catch (error) {
        console.error(error)
    }
}

export const getHeight = computed(() => {
    if (content.value?.height === null) {
        return undefined
    }

    return `${content.value?.height}px`
})
